<script setup>
import {Link as InertiaLink} from '@inertiajs/vue3';
defineOptions({
    inheritAttrs: true,
});
const props = defineProps({
    anchor: {
        type: Boolean,
        default: false,
    },
    color: {
        type: String,
        default: 'base-content',
    },
    hoverColor: {
        type: String,
        default: 'accent',
    },
});

const classes = `underline text-sm text-${props.color} hover:text-${props.hoverColor} rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-${props.hoverColor}`;
</script>
<template>
    <a v-if="anchor" :class="classes">
        <slot />
    </a>
    <InertiaLink v-else :class="classes">
        <slot />
    </InertiaLink>
</template>
